import React from 'react'
import styled from 'particles/themes/styled'
import { theme } from '../../theme'
import Tooltip from 'particles/Tooltip'

export const NavbarWrapper = styled.div`
    width: 70px;
    box-sizing: border-box;
    height: 100vh;
    padding: 20px 17px 60px;
    background-color: ${theme.newColors.neutral50};
    box-shadow: 2px 0px 8px rgba(0, 0, 0, 0.06);
    z-index: 200;
    .nav-container {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        height: 100%;
    }
    .upper-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .second-container {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        height: 109px;
        gap: ${({ theme }) => theme.spacing[400]};

        & > div {
            flex-shrink: 0;
        }
    }
    .navbar-link {
        margin-left: 0;
        padding: 0;
    }
    @media screen and (max-width: 768px) {
        display: none;
    }
`
interface NavIconButtonProps extends React.HTMLProps<HTMLDivElement> {
    label?: string
    isExtend?: boolean
}

const BaseNavIconButton = styled.div<NavIconButtonProps>`
    position: relative;
    width: 100%;
    z-index: 120;
    a {
        display: block;
        width: 100%;
        text-decoration: none;
    }
    .nav-button {
        display: flex;
        justify-content: ${props => (props.isExtend ? 'flex-start' : 'center')};
        align-items: center;
        padding-left: ${props => (props.isExtend ? '4px' : 0)};
        .button-name {
            margin-left: 4px;
        }
    }
    .navlink--active {
        button {
            color: ${theme.newColors.primary300};
            font-weight: ${theme.fontWeight.medium};
        }
    }
`

export const NavIconButton: React.FC<NavIconButtonProps> = ({ onClick, label, isExtend, children }) => {
    return (
        <Tooltip label={label} placement="right">
            <BaseNavIconButton onClick={onClick} isExtend={isExtend}>
                {children}
            </BaseNavIconButton>
        </Tooltip>
    )
}
